<script lang="ts" setup>
const exchanges = [
  {
    id: 1,
    img: '/images/home/gate.png',
    name: 'Gate',
    link: 'https://www.gate.com/trade/LONG_USDT',
  },
  {
    id: 2,
    img: '/images/home/mexc.png',
    name: 'Mexc',
    link: 'https://www.mexc.com/price/LONG',
    class: 'w-30',
  },
]
</script>

<template>
  <div
    class="flex flex-col justify-center items-center gap-5 mx-auto px-5 lg:flex-row lg:flex-wrap lg:px-5 min-[860px]:px-0"
  >
    <NuxtLink
      v-for="ex in exchanges"
      :key="ex.id"
      :to="ex.link"
      target="_blank"
      rel="noopener noreferrer"
      class="max-w-97 max-h-38 h-full min-h-38 w-full border-1 border-solid border-[#40424F] rounded-xl flex flex-wrap items-center justify-center overflow-hidden"
    >
      <NuxtImg
        :src="ex.img"
        :alt="ex.name"
        :class="ex.class"
        class="flex h-full"
      />
    </NuxtLink>
  </div>
</template>
